import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { CountryService } from '../../commonservice/countrylist.service';
import { utilityService } from '../../commonservice/utility.service';
import { AppSettings } from '../../_common/constants/app.constants';
import { CountryDetail } from './countryinformation';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-countrylist',
  templateUrl: 'countrylist.component.html',
  providers: [Modal, CountryService, utilityService]
})
export class countrylist implements OnInit, OnDestroy, ModalComponent<CustomModalContext> {
  model: any = {};
  isMore = false; // For Expanding country list class
  context: CustomModalContext;
  modalData: any;
  countryinfo: CountryDetail;
  preferredCountrycollection = [];
  countrycollection = [];
  appSettings: any;
  constructor(
    private router: Router,
    private countryserv: CountryService,
    public utilserv: utilityService,
    public dialog: DialogRef<CustomModalContext>,
    public domSanitizer: DomSanitizer,
    public translate: TranslateService
  ) {
    this.modalData = this.dialog.context.modalData;
    this.getcountrylistfromservice();
    this.appSettings = AppSettings;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {
    this.dialog.context.modalData.next = {};
    //if (this.modalData.src != 'pickuptype') {
      this.isMore = true;
      document.getElementById('_content').classList.add('showContent');
      document.getElementById('_content').classList.remove('hideContent');
    //}
  }
  // Function will intitated Country List and Save on a session variable going forward will use this for getting Country related information
  getcountrylistfromservice() {
    const _self = this;
    let enevelop = `{"UpdatedTimeStamp": ""}`;
    let countrycollection = this.countryserv.getCountryListFromLocaleEx();

    this.countrycollection = countrycollection.filter(country => country.IsDestination === true);
    _self.countrycollection.forEach(element => {
      this.utilserv.busy = _self.utilserv.getCountryImage(element.CountryCode).subscribe(
        res => {
          element.CountryImage = res;
        },
        error => {
          console.log(error);
        }
      );
    });

    if (this.modalData.src == 'pickuptype') {
      this.utilserv.busy = this.countryserv.getPreferredCountrylist().subscribe(
        data => {
          if (data.Envelope.Body.Top4CountriesUsedInMT.Top4Countries.string != undefined) {
            let countryList = this.utilserv.getArray(data.Envelope.Body.Top4CountriesUsedInMT.Top4Countries.string);
            countryList.forEach(
              element => {
                let countryinfo: any = {};
                countryinfo.CountryCode = _self.utilserv.getObjectText(element);
                countryinfo.CountryName = _self.countrycollection.filter(function(country) {
                  return country.CountryCode === countryinfo.CountryCode;
                })[0].CountryNames[0].Name;

                _self.utilserv.busy = _self.utilserv.getCountryImage(element).subscribe(
                  res => {
                    countryinfo.CountryImage = res;
                  },
                  error => {
                    console.log('Observer got a next value: ' + error);
                  }
                );

                _self.countrycollection = _self.countrycollection.filter(item => item.CountryCode !== _self.utilserv.getObjectText(element));
                _self.preferredCountrycollection.push(countryinfo);
              },
              error => {
                console.log(error);
              }
            );
          }
        },
        error => {
          console.log('Observer got a next value: ' + error);
        }
      );
    }

    // });
  }
  onSelect(country) {
    this.dialog.context.modalData.next = country;
    this.dialog.close();
  }
  loadFakeImg(event) {
    event.currentTarget.src = 'assets/images/round_emty.png';
  }
  closePopup() {
    this.dialog.close();
  }
  switchClass(object) {
    this.isMore = true;
    if (object.currentTarget.title === 'more') {
      document.getElementById('_content').classList.add('showContent');
      document.getElementById('_content').classList.remove('hideContent');
    } else {
      document.getElementById('_content').classList.add('hideContent');
      document.getElementById('_content').classList.remove('showContent');
    }
  }
  ngOnDestroy() {
    // this.dialog.close();
  }
  errorHandler(event) {
    event.currentTarget.style.display = 'none';
    //event.currentTarget.src = 'assets/images/round_emty.png';
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/countrylist.component.ts